import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../context/ToastContext';
import logo from '../assets/logo.png';
import { UserRoleContext } from '../context/UserRoleContext';
import { EventContext } from '../context/EventContext';
import { ROUTES } from '../constants/routes';


const RegistrantUpdateSuccessComponent: React.FC = () => {
  const navigate = useNavigate();
  const { userRole } = useContext(UserRoleContext);
  const { event_code } = useParams<{ event_code: string }>();


  const { currentEvent } = useContext(EventContext); // Event context
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(ROUTES.REGISTRANTS_LIST);
    }, 10000);
  
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ alignContent: 'center', justifyContent: 'center', display: 'flex', width: '100%', height: '600px'}}>
      <div className="card" style={{ maxWidth: '600px', backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', textAlign: 'center', maxHeight: '400px', marginTop: '100px'}}>
          <img src={logo} alt="Cyne Up" style={{ maxWidth: '50%' }} />
        <h1 style={{marginTop: '0px'}}>You Have Successfully Updated The Cyne Up Registrant!</h1>
        <p>Thank you for using the fastest Cyber Sign Up!</p>
        <h4>{`You will be redirected to to your registrant list momentarily.`}</h4>
        { userRole && <div className='buttonsRow'>
      <button onClick={() => {navigate(ROUTES.HOME)}}>Return To Home</button>
        </div>}
      </div>
    </div>
  );
};

export default RegistrantUpdateSuccessComponent;
